<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/new-zealand')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/new-zealand/ata-rangi')">Ata Rangi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/new-zealand/bell-hill-vineyards')">Bell Hill Vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/new-zealand/craggy-range')">Craggy Range
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/new-zealand/dog-point-vineyards')">Dog Point Vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/new-zealand/millton-vineyards-and-winery')">Millton
                        Vineyards and Winery
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/new-zealand/pyramid-valley-vineyards')">Pyramid Valley
                        Vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/new-zealand/rippon-vineyards')">Rippon Vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/new-zealand/trinity-hill')">Trinity Hill
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/new-zealand')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Pyramid Valley Vineyards</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Una delle cose meravigliose che la nuova ondata mondiale di vino ha portato è un aumento
                        consapevolezza delle tante piccole grandi aziende vinicole là fuori. Con oltre 700 produttori che producono variando
                        stili delle due isole principali, le tecniche potrebbero essere considerate giovani, ma il risultato finale
                        è spesso stupendo. Una delle regioni vinicole del nuovo mondo in più rapida evoluzione (che copre il Sudafrica
                        e California così come Australia e Sud America) la Nuova Zelanda potrebbe essere un po' bagnata dietro
                        le orecchie rispetto agli europei ma ciò non significa che debba essere trascurato quando
                        arriva a investire.
                    </div>

                    <div class="howto-title2">La regionalità gioca un ruolo importante</div>
                    <div class="howto-text">
                        I vigneti di Pyramid Valley (o PVV in breve), sono una piccola azienda vinicola così grande. Fondata da Claudia Weersing e suo marito Mike nel 2000, Pyramid Valley ha iniziato a farsi un nome quando ha istituito l'agricoltura biodinamica per la sua tenuta biodinamica di 2,2 ettari. Mike e Claudia, entrambi americani con una carriera di alto livello a Manhattan, avevano rinunciato alla corsa al successo e si erano trasferiti in Georgia alcuni anni prima, eppure Mike, uno studioso erudito e pacato, faticava a trovare la sua vocazione. Dopo aver studiato enologia a Bordeaux, la coppia si è trasferita in Nuova Zelanda nel 1996 e Mike ha iniziato a lavorare come enologo con Neudorf a Nelson. Tuttavia, avevano un forte desiderio di produrre il proprio vino, in particolare Pinot Noir e Chardonnay, e alla fine hanno avuto successo nel 2000, quando si sono imbattuti nella tenuta di Waikari, ricca di calcare, a North Canterbury. Avanti veloce di quasi due decenni e sia la Weersings Home Block che la Growers Collection sono esempi lampanti di quanto possano essere speciali non solo i vini neozelandesi, ma mostrino il potenziale dei vini del nuovo mondo con brio e gusto.
                    </div>

                    <div class="howto-title2">Espansione per il 21° secolo</div>
                    <div class="howto-text">
                        Non siamo i soli a notare il superlativo successo di Pyramid. Nel 2018 Pyramid Valley a una multa
                        start-up vinicola co-fondata da Steve Smith MW, che ha anche fondato Craggy Range, per NZ $ 8 milioni (€ 4,6 milioni).
                        Ciò rafforza la convinzione che ci si aspettino grandi cose dal nuovo mondo Pinot Nero e
                        Chardonnay e potrebbe non mancare molto tempo prima che la regione esploda. Per chi vuole
                        per entrare al piano terra, PVV potrebbe fornire quell'ingresso.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Pyramid Valley Vineyards</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Eines der wunderbaren Dinge, die die neue Weltweinwelle hervorgebracht hat, ist eine Steigerung
                        Bewusstsein für die vielen tollen kleinen Weingüter da draußen. Mit über 700 Herstellern, die abwechslungsreich produzieren
                        Stile von den beiden Hauptinseln, die Techniken mögen als jung gelten, aber das Endergebnis
                        ist oft erstaunlich. Eine der sich am schnellsten entwickelnden Weinregionen der Neuen Welt (die Südafrika umfasst).
                        und Kalifornien sowie Australien und Südamerika) Neuseeland könnte dahinter etwas nass sein
                        die Ohren im Vergleich zu den Europäern, aber das bedeutet nicht, dass es übersehen werden sollte, wenn es so ist
                        kommt zum Investieren.
                    </div>

                    <div class="howto-title2">Regionalität spielt eine wichtige Rolle</div>
                    <div class="howto-text">
                        Pyramid Valley Vineyards (oder kurz PVV) ist ein solch tolles kleines Weingut. Pyramid Valley wurde im Jahr 2000 von Claudia Weersing und ihrem Ehemann Mike gegründet und machte sich einen Namen, als es auf seinem 2,2 Hektar großen biodynamischen Anwesen biodynamische Landwirtschaft einführte. Mike und Claudia, beide Amerikaner mit hochkarätigen Karrieren in Manhattan, hatten das Hamsterrad einige Jahre zuvor aufgegeben und waren nach Georgia gezogen, doch Mike, ein ruhiger, gebildeter Gelehrter, hatte Mühe, seine Berufung zu finden. Nach dem Studium der Önologie in Bordeaux zog das Paar 1996 nach Neuseeland und Mike begann seine Arbeit als Winzer bei Neudorf in Nelson. Sie hatten jedoch den starken Wunsch, ihren eigenen Wein herzustellen, vor allem Pinot Noir und Chardonnay, und landeten schließlich im Jahr 2000 auf dem richtigen Weg, als sie zufällig auf das kalksteinreiche Waikari-Anwesen in North Canterbury stießen. Fast zwei Jahrzehnte später sind sowohl der Weersings Home Block als auch die Growers Collection herausragende Beispiele dafür, wie besonders nicht nur neuseeländische Weine sein können, sondern zeigen auch mit Elan und Begeisterung das Potenzial der Weine der neuen Welt.
                    </div>

                    <div class="howto-title2">Erweiterung für das 21. Jahrhundert</div>
                    <div class="howto-text">
                        Wir sind nicht die Einzigen, die den überragenden Erfolg von Pyramid bemerken. Im Jahr 2018 wurde Pyramid Valley zu einer Geldstrafe verurteilt
                        Wein-Start-up, mitbegründet von Steve Smith MW, der auch Craggy Range gründete, für 8 Mio. NZ$ (4,6 Mio. €).
                        Dies bestärkt die Überzeugung, dass von den Pinot Noirs der neuen Welt Großes erwartet wird
                        Chardonnays und es bleibt möglicherweise nicht mehr viel Zeit, bis die Region explodiert. Für diejenigen, die wollen
                        Um vom Erdgeschoss aus einzusteigen, bietet PVV möglicherweise diesen Einstieg an.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Pyramid Valley Vineyards</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        L'une des choses merveilleuses que la nouvelle vague mondiale de vins a provoquées est une augmentation
                        conscience des nombreux grands petits vignobles là-bas. Avec plus de 700 producteurs produisant divers
                        styles des deux îles principales, les techniques peuvent être considérées comme jeunes, mais le résultat final
                        est souvent époustouflant. L'une des régions viticoles du nouveau monde les plus dynamiques (qui couvre l'Afrique du Sud
                        et la Californie ainsi que l'Australie et l'Amérique du Sud) la Nouvelle-Zélande pourrait être un peu mouillée derrière
                        les oreilles par rapport aux européens mais cela ne veut pas dire qu'il faut le négliger quand il
                        vient d'investir.
                    </div>

                    <div class="howto-title2">La régionalité joue un rôle important</div>
                    <div class="howto-text">
                        Les vignobles de Pyramid Valley (ou PVV en abrégé) sont l'un de ces grands vignobles. Fondée par Claudia Weersing et son mari Mike en 2000, Pyramid Valley a commencé à se faire un nom en établissant une agriculture biodynamique pour son domaine biodynamique de 2,2 hectares. Mike et Claudia, tous deux américains avec des carrières de haut vol à Manhattan, avaient abandonné la course effrénée et avaient déménagé en Géorgie quelques années auparavant, mais Mike, un érudit érudit à la voix calme, avait du mal à trouver sa vocation. Après des études d'œnologie à Bordeaux, le couple s'installe en Nouvelle-Zélande en 1996 et Mike commence à travailler comme vigneron chez Neudorf à Nelson. Cependant, ils avaient un fort désir de faire leur propre vin, notamment du pinot noir et du chardonnay, et ont finalement touché la terre en 2000 lorsqu'ils sont tombés sur le domaine riche en calcaire de Waikari à North Canterbury. Avance rapide de près de deux décennies et le Weersings Home Block et la Growers Collection sont des exemples éclatants de la particularité non seulement des vins néo-zélandais, mais montrent le potentiel des vins du nouveau monde avec panache et enthousiasme.
                    </div>

                    <div class="howto-title2">Expansion pour le 21e siècle</div>
                    <div class="howto-text">
                        Nous ne sommes pas les seuls à remarquer le succès exceptionnel de Pyramid. En 2018 Pyramid Valley à une amende
                        start-up viticole cofondée par Steve Smith MW, également fondateur de Craggy Range, pour 8 M$ NZ (4,6 M€).
                        Cela renforce la conviction que de grandes choses sont attendues des pinots noirs du nouveau monde et
                        Chardonnays et il ne restera peut-être plus beaucoup de temps avant que la région n'explose. Pour ceux qui veulent
                        pour entrer au niveau du sol, PVV pourrait bien fournir cette entrée.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Pyramid Valley Vineyards</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        One of the marvellous things that the new world wine wave has brought about is an increased
                        awareness of the many great little wineries out there. With over 700 producers producing varying
                        styles from the two main islands, the techniques might be considered young, but the end result
                        is often stupendous. One of the fastest moving new world wine regions (that covers South Africa
                        and California as well as Australia and South America) New Zealand might be a little wet behind
                        the ears compared to the Europeans but that doesn&#39;t mean it should be overlooked when it
                        comes to investing.
                    </div>

                    <div class="howto-title2">Regionality plays an important role</div>
                    <div class="howto-text">
                        Pyramid Valley vineyards (or PVV for short), is one such great little winery. Founded by Claudia Weersing and her husband Mike in 2000, Pyramid Valley began making a name for itself when it established biodynamic farming for its 2.2-hectare biodynamic estate. Mike and Claudia, both American with high flying Manhatten careers, had given up the rat race and moved to Georgia some years previously, yet Mike, a quiet-spoken, erudite, scholar struggled to find his calling. After studying oenology in Bordeaux, the couple moved to New Zealand in 1996 and Mike began work as a winemaker with Neudorf in Nelson. However, they had a strong desire to make their own wine, notably Pinot Noir and Chardonnay, and finally hit pay dirt in 2000 when they stumbled upon the limestone-rich, Waikari estate in North Canterbury. Fast forward almost two decades and both the Weersings Home Block and Growers Collection are soaring examples of how special not only New Zealand wines can be, but show the potential of the new world wines with panache and gusto.
                    </div>

                    <div class="howto-title2">Expansion for the 21st-century</div>
                    <div class="howto-text">
                        We are not alone in noticing Pyramid’s superlative success. In 2018 Pyramid Valley to a fine
                        wine start-up co-founded by Steve Smith MW, who also founded Craggy Range, for NZ$8m (€4.6m).
                        This bolsters the belief that great things are expected from new world Pinot Noirs and
                        Chardonnays and there may not be much time left before the region explodes. For those who want
                        to get in on the ground level, PVV may well provide that entry.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "PyramidValleyVineyards",
    data() {
        return {
            select: {report: 'Pyramid Valley Vineyards', src: '/wine-guide/new-zealand/pyramid-valley-vineyards'},
            items: [
                {report: 'Ata Rangi', src: '/wine-guide/new-zealand/ata-rangi'},
                {report: 'Bell Hill Vineyards', src: '/wine-guide/new-zealand/bell-hill-vineyards'},
                {report: 'Craggy Range', src: '/wine-guide/new-zealand/craggy-range'},
                {report: 'Dog Point Vineyards', src: '/wine-guide/new-zealand/dog-point-vineyards'},
                {report: 'Millton Vineyards and Winery', src: '/wine-guide/new-zealand/millton-vineyards-and-winery'},
                {report: 'Pyramid Valley Vineyards', src: '/wine-guide/new-zealand/pyramid-valley-vineyards'},
                {report: 'Rippon Vineyards', src: '/wine-guide/new-zealand/rippon-vineyards'},
                {report: 'Trinity Hill', src: '/wine-guide/new-zealand/trinity-hill'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    },
    head: {
        title: 'Pyramid Valley Vineyards | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the exquisite wines of Pyramid Valley Vineyards, a premium wine producer located in the heart of New Zealand\'s wine country. Experience the unique blend of tradition and innovation in every bottle.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}
.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
